import { Box, styled } from '@mui/material';

export const MainBox = styled(Box)({
  flex: 1, 
  display: 'flex', 
  flexDirection: 'column', 
  minHeight: 0
})